import { useSelector } from 'react-redux';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { IRootState } from '@/store';

const labels: Record<string, string> = {
    idle: 'Tempo real: aguardando',
    connecting: 'Tempo real: conectando…',
    connected: 'Tempo real: conectado',
    reconnecting: 'Tempo real: reconectando…',
    disconnected: 'Tempo real: offline',
    error: 'Tempo real: erro de conexão',
};

export const ConnectionBadge = () => {
    const { status, lastError } = useSelector((s: IRootState) => s.realtime);

    const color =
        status === 'connected' ? 'bg-success' : status === 'connecting' || status === 'reconnecting' ? 'bg-warning' : status === 'error' || status === 'disconnected' ? 'bg-danger' : 'bg-gray-400';

    const tooltip = lastError ? `${labels[status] ?? status} — ${lastError}` : (labels[status] ?? status);

    return (
        <Tippy content={tooltip} placement="bottom">
            <span className="relative flex items-center justify-center p-2.5 rounded-full bg-white-light/40 dark:bg-surface-hover">
                <span className={`inline-block w-2.5 h-2.5 rounded-full ${color}`} />
                {(status === 'connecting' || status === 'reconnecting') && <span className={`absolute inline-block w-2.5 h-2.5 rounded-full ${color} opacity-60 animate-ping`} />}
            </span>
        </Tippy>
    );
};

export default ConnectionBadge;
